import { throttle } from '../utils/promise-utils';
import { axios } from './../utils/axios.js';
import { path } from 'ramda';
import { urls } from './../config.js';
var getAll = throttle(function () {
  return axios().then(function (api) {
    return api.get(urls.apiV2('/app-notification')).then(path(['data', 'data']));
  });
});

/**
 * `getAll()` Fetches all notifications for the currently active user from the
 * API and returns a Promise. When successful, this promise resolves with an
 * array of notification objects as defined at
 * https://docs.huggg.me/entities/notification/. If the request fails, the
 * promise is rejected with the failing request object.
 *
 */
export default {
  getAll: getAll
};